import { Avatar } from '@material-tailwind/react';
import React from 'react';
import ModalImg from '../Modal/ModalImg';
import { CameraOff } from 'lucide-react';

const TdImg = ({ foto }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    if (foto) {
      setOpen((cur) => !cur);
    }
  };

  return (
    <>
      {foto && (
        <Avatar src={foto} size="md" variant="square" withBorder={false} onClick={handleOpen} />
      )}

      {!foto && (
        <Avatar
          src="/img/not-img.png"
          size="md"
          variant="square"
          withBorder={false}
          onClick={handleOpen}
        />
      )}

      {open && <ModalImg open={open} handleOpen={handleOpen} foto={foto} />}
    </>
  );
};

export default TdImg;
